'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Checkbox, Divider } from '@common/components';
import { SvgDelete } from '@common/icon';
import { cn } from '@core/utils';
import { Fragment } from 'react';
import { Image } from '@/components/client';
import { QuantityStepper } from '@/components/molecule/QuantityStepper';
export interface CartOption {
  cartItemOptionId: string;
  productOptionItemIds: string[];
  optionName: string;
  quantity: number;
  price: number;
  extraPrice: number;
  soldOutYN: boolean;
  remainingStockCount?: number;
}
export interface CartProduct {
  mallProductId: string;
  productName: string;
  mainImageUrl: string;
  checked: boolean;
  soldOutYN: boolean;
  regularPrice: number;
  currentPrice: number;
  discountPrice: number;
  deliveryFee: number;
  freeShippingAvailable: boolean;
  freeShippingAmount: number;
  options: CartOption[];
}
export interface CartShop {
  mallVendorId: string;
  govCodeName: string;
  vendorName: string;
  checked: boolean;
  products: CartProduct[];
}
interface CartShopGroupProps {
  shop: CartShop;
  onShopCheck: (mallVendorId: string, checked: boolean) => void;
  onProductCheck: (mallVendorId: string, mallProductId: string, checked: boolean) => void;
  onRemoveProduct: (mallVendorId: string, mallProductId: string) => void;
  onRemoveOption: (mallVendorId: string, mallProductId: string, cartItemOptionId: string) => void;
  onQuantityChange: (mallVendorId: string, mallProductId: string, cartItemOptionId: string, quantity: number) => void;
  onOptionChange: (mallVendorId: string, product: CartProduct) => void;
  onOrder: (mallProductId: string) => void;
}
export const CartShopGroup = t0 => {
  const $ = _c(40);
  const {
    shop,
    onShopCheck,
    onProductCheck,
    onRemoveProduct,
    onRemoveOption,
    onQuantityChange,
    onOptionChange,
    onOrder
  } = t0;
  let t1;
  if ($[0] !== onShopCheck || $[1] !== shop.mallVendorId) {
    t1 = checked => onShopCheck(shop.mallVendorId, checked);
    $[0] = onShopCheck;
    $[1] = shop.mallVendorId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== shop.checked || $[4] !== t1) {
    t2 = <Checkbox className="p-0 [&_button[data-state=checked]:not(:disabled)]:bg-O-400" checked={shop.checked} onCheckedChange={t1} />;
    $[3] = shop.checked;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== shop.govCodeName) {
    t3 = <span className="flex h-22 items-center justify-center rounded-none bg-Gray-200 px-6 py-3 font-600 text-Gray-600 typo-body4">{shop.govCodeName}</span>;
    $[6] = shop.govCodeName;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== shop.vendorName) {
    t4 = <span className="font-600 text-Gray-600 typo-body3">{shop.vendorName}</span>;
    $[8] = shop.vendorName;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex items-center gap-4">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <header className="flex items-center gap-4">{t2}{t5}</header>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("flex flex-col gap-40", "mobile-tablet:gap-28");
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onOptionChange || $[18] !== onOrder || $[19] !== onProductCheck || $[20] !== onQuantityChange || $[21] !== onRemoveOption || $[22] !== onRemoveProduct || $[23] !== shop.mallVendorId || $[24] !== shop.products) {
    let t9;
    if ($[26] !== onOptionChange || $[27] !== onOrder || $[28] !== onProductCheck || $[29] !== onQuantityChange || $[30] !== onRemoveOption || $[31] !== onRemoveProduct || $[32] !== shop.mallVendorId || $[33] !== shop.products.length) {
      t9 = (product, index) => <Fragment key={product.mallProductId}><CartProductCard mallVendorId={shop.mallVendorId} product={product} isLast={index === shop.products.length - 1} onProductCheck={onProductCheck} onRemoveProduct={onRemoveProduct} onRemoveOption={onRemoveOption} onQuantityChange={onQuantityChange} onOptionChange={onOptionChange} onOrder={onOrder} /></Fragment>;
      $[26] = onOptionChange;
      $[27] = onOrder;
      $[28] = onProductCheck;
      $[29] = onQuantityChange;
      $[30] = onRemoveOption;
      $[31] = onRemoveProduct;
      $[32] = shop.mallVendorId;
      $[33] = shop.products.length;
      $[34] = t9;
    } else {
      t9 = $[34];
    }
    t8 = shop.products.map(t9);
    $[17] = onOptionChange;
    $[18] = onOrder;
    $[19] = onProductCheck;
    $[20] = onQuantityChange;
    $[21] = onRemoveOption;
    $[22] = onRemoveProduct;
    $[23] = shop.mallVendorId;
    $[24] = shop.products;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[35] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t6 || $[38] !== t9) {
    t10 = <div className="flex flex-col gap-16 mobile-tablet:px-20">{t6}{t9}</div>;
    $[37] = t6;
    $[38] = t9;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  return t10;
};
interface CartProductCardProps {
  mallVendorId: string;
  product: CartProduct;
  isLast: boolean;
  onProductCheck: (mallVendorId: string, mallProductId: string, checked: boolean) => void;
  onRemoveProduct: (mallVendorId: string, mallProductId: string) => void;
  onRemoveOption: (mallVendorId: string, mallProductId: string, cartItemOptionId: string) => void;
  onQuantityChange: (mallVendorId: string, mallProductId: string, cartItemOptionId: string, quantity: number) => void;
  onOptionChange: (mallVendorId: string, product: CartProduct) => void;
  onOrder: (mallProductId: string) => void;
}
const CartProductCard = t0 => {
  const $ = _c(89);
  const {
    mallVendorId,
    product,
    isLast,
    onProductCheck,
    onRemoveProduct,
    onRemoveOption,
    onQuantityChange,
    onOptionChange,
    onOrder
  } = t0;
  let t1;
  if ($[0] !== product.options || $[1] !== product.soldOutYN) {
    t1 = product.soldOutYN || product.options.some(_temp);
    $[0] = product.options;
    $[1] = product.soldOutYN;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const hasSoldOutOption = t1;
  let t2;
  if ($[3] !== product.options || $[4] !== product.soldOutYN) {
    t2 = product.soldOutYN || product.options.every(_temp2);
    $[3] = product.options;
    $[4] = product.soldOutYN;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isAllSoldOut = t2;
  const t3 = product.productName;
  let t4;
  if ($[6] !== mallVendorId || $[7] !== onProductCheck || $[8] !== product.mallProductId) {
    t4 = checked => onProductCheck(mallVendorId, product.mallProductId, checked);
    $[6] = mallVendorId;
    $[7] = onProductCheck;
    $[8] = product.mallProductId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== hasSoldOutOption || $[11] !== product.checked || $[12] !== t4) {
    t5 = <Checkbox className="p-0 [&_button[data-state=checked]:not(:disabled)]:bg-O-400" checked={product.checked} disabled={hasSoldOutOption} onCheckedChange={t4} />;
    $[10] = hasSoldOutOption;
    $[11] = product.checked;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = product.mainImageUrl;
  const t7 = product.productName;
  const t8 = product.soldOutYN && "opacity-50";
  let t9;
  if ($[14] !== t8) {
    t9 = cn("size-104 shrink-0 bg-Gray-300 object-cover mobile-tablet:size-72", t8);
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== product.mainImageUrl || $[17] !== product.productName || $[18] !== t9) {
    t10 = <Image src={t6} alt={t7} width={104} height={104} className={t9} />;
    $[16] = product.mainImageUrl;
    $[17] = product.productName;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== product.productName) {
    t11 = <p className="flex-1 font-500 text-Gray-900 typo-body2 mobile-tablet:typo-body4">{product.productName}</p>;
    $[20] = product.productName;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== product.options || $[23] !== product.soldOutYN) {
    t12 = (product.soldOutYN || product.options.some(_temp3)) && <span className="shrink-0 bg-Gray-600 px-6 py-2 font-600 text-Gray-white typo-caption2">품절</span>;
    $[22] = product.options;
    $[23] = product.soldOutYN;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = <div className="flex flex-1 items-center gap-4">{t11}{t12}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = `${product.productName} 삭제`;
  let t15;
  if ($[28] !== mallVendorId || $[29] !== onRemoveProduct || $[30] !== product.mallProductId) {
    t15 = () => onRemoveProduct(mallVendorId, product.mallProductId);
    $[28] = mallVendorId;
    $[29] = onRemoveProduct;
    $[30] = product.mallProductId;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SvgDelete className="size-20 text-Gray-600" />;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t15) {
    t17 = <button type="button" aria-label={t14} className="shrink-0" onClick={t15}>{t16}</button>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t13 || $[37] !== t17) {
    t18 = <div className="flex flex-1 items-start justify-between gap-4">{t13}{t17}</div>;
    $[36] = t13;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t10 || $[40] !== t18) {
    t19 = <div className="flex gap-8">{t10}{t18}</div>;
    $[39] = t10;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== mallVendorId || $[43] !== onQuantityChange || $[44] !== onRemoveOption || $[45] !== product.currentPrice || $[46] !== product.mallProductId || $[47] !== product.options || $[48] !== product.regularPrice) {
    let t21;
    if ($[50] !== mallVendorId || $[51] !== onQuantityChange || $[52] !== onRemoveOption || $[53] !== product.currentPrice || $[54] !== product.mallProductId || $[55] !== product.regularPrice) {
      t21 = option => <li key={option.cartItemOptionId} className="flex flex-col gap-16 bg-Gray-50 p-20 mobile-tablet:gap-8 mobile-tablet:p-12"><p className="text-Gray-600 typo-body3 mobile-tablet:typo-caption1">{option.optionName}</p>{option.soldOutYN ? <div className="flex items-center justify-end gap-8"><span className="font-500 text-Gray-500 line-through typo-body3 mobile-tablet:typo-body4">{(option.price * option.quantity).toLocaleString()}원</span><span className="font-500 text-R-400 typo-body3 mobile-tablet:typo-body4">품절</span></div> : <div className="flex items-center justify-between"><QuantityStepper className="rounded-none" count={option.quantity} onCountChange={count => onQuantityChange(mallVendorId, product.mallProductId, option.cartItemOptionId, count)} onDelete={() => onRemoveOption(mallVendorId, product.mallProductId, option.cartItemOptionId)} /><div className="flex items-center gap-8">{product.currentPrice < product.regularPrice && <span className="font-400 text-Gray-500 line-through typo-caption1">{((product.regularPrice + option.extraPrice) * option.quantity).toLocaleString()}원</span>}<span className="font-600 text-Gray-900 typo-body3 mobile-tablet:typo-body4">{(option.price * option.quantity).toLocaleString()}원</span>{(option.remainingStockCount ?? 0) > 0 && <span className="font-500 text-O-400 typo-caption1">{option.remainingStockCount}개 남음</span>}</div></div>}</li>;
      $[50] = mallVendorId;
      $[51] = onQuantityChange;
      $[52] = onRemoveOption;
      $[53] = product.currentPrice;
      $[54] = product.mallProductId;
      $[55] = product.regularPrice;
      $[56] = t21;
    } else {
      t21 = $[56];
    }
    t20 = product.options.slice().sort(_temp4).map(t21);
    $[42] = mallVendorId;
    $[43] = onQuantityChange;
    $[44] = onRemoveOption;
    $[45] = product.currentPrice;
    $[46] = product.mallProductId;
    $[47] = product.options;
    $[48] = product.regularPrice;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[57] !== t20) {
    t21 = <ul className="flex flex-col gap-6">{t20}</ul>;
    $[57] = t20;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] !== t19 || $[60] !== t21) {
    t22 = <div className="flex flex-col gap-12 mobile-tablet:gap-8">{t19}{t21}</div>;
    $[59] = t19;
    $[60] = t21;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== isAllSoldOut || $[63] !== mallVendorId || $[64] !== onOptionChange || $[65] !== product) {
    t23 = () => {
      if (isAllSoldOut) {
        return;
      }
      onOptionChange(mallVendorId, product);
    };
    $[62] = isAllSoldOut;
    $[63] = mallVendorId;
    $[64] = onOptionChange;
    $[65] = product;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  let t24;
  if ($[67] !== isAllSoldOut || $[68] !== t23) {
    t24 = <Button theme="sub-line" dimensions="H48" disabled={isAllSoldOut} className="flex-1 !rounded-none font-600 mobile-tablet:h-32 mobile-tablet:typo-caption1" onClick={t23}>옵션 변경</Button>;
    $[67] = isAllSoldOut;
    $[68] = t23;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== onOrder || $[71] !== product.mallProductId) {
    t25 = () => onOrder(product.mallProductId);
    $[70] = onOrder;
    $[71] = product.mallProductId;
    $[72] = t25;
  } else {
    t25 = $[72];
  }
  let t26;
  if ($[73] !== isAllSoldOut || $[74] !== t25) {
    t26 = <Button theme="primary-line" dimensions="H48" disabled={isAllSoldOut} className="flex-1 !rounded-none font-600 mobile-tablet:h-32 mobile-tablet:typo-caption1" onClick={t25}>결제하기</Button>;
    $[73] = isAllSoldOut;
    $[74] = t25;
    $[75] = t26;
  } else {
    t26 = $[75];
  }
  let t27;
  if ($[76] !== t24 || $[77] !== t26) {
    t27 = <div className="flex gap-8 mobile-tablet:gap-4">{t24}{t26}</div>;
    $[76] = t24;
    $[77] = t26;
    $[78] = t27;
  } else {
    t27 = $[78];
  }
  let t28;
  if ($[79] !== isLast) {
    t28 = !isLast && <Divider className="mt-20 w-full bg-Gray-300 mobile-tablet:mt-16" />;
    $[79] = isLast;
    $[80] = t28;
  } else {
    t28 = $[80];
  }
  let t29;
  if ($[81] !== t22 || $[82] !== t27 || $[83] !== t28) {
    t29 = <div className="flex flex-1 flex-col gap-20 mobile-tablet:gap-12">{t22}{t27}{t28}</div>;
    $[81] = t22;
    $[82] = t27;
    $[83] = t28;
    $[84] = t29;
  } else {
    t29 = $[84];
  }
  let t30;
  if ($[85] !== product.productName || $[86] !== t29 || $[87] !== t5) {
    t30 = <article aria-label={t3} className="flex gap-8">{t5}{t29}</article>;
    $[85] = product.productName;
    $[86] = t29;
    $[87] = t5;
    $[88] = t30;
  } else {
    t30 = $[88];
  }
  return t30;
};
function _temp(o) {
  return o.soldOutYN;
}
function _temp2(o_0) {
  return o_0.soldOutYN;
}
function _temp3(o_1) {
  return o_1.soldOutYN;
}
function _temp4(a, b) {
  return Number(a.soldOutYN) - Number(b.soldOutYN);
}